import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IVideoListProps } from '../components/video-list/video-list';
import { IYoutubeVideoProps } from '../components/youtube-video/youtube-video';
import { YoutubeVideoModel } from './youtube-video-model';

export class VideoListModel extends ContentItem {
  get videos(): IYoutubeVideoProps[] {
    const nodes = get(this._config, 'elements.videos.value', []);
    const modeledVideos = nodes.map((video: IYoutubeVideo) =>
      YoutubeVideoModel.create(video)
    );
    return modeledVideos;
  }

  public static create(data: IVideoList): IVideoListProps {
    const { videos } = new VideoListModel(data);

    return {
      videos
    };
  }
}
